import { addDays, todayString } from './dateHelpers';
import { typeGant } from '../../../enum/gant.enum'

export const svgProps = {
  nameWidth: 300,
  startWidth: 150,
  endWidth: 150,
  sizeDay: 30,
  sizeWeek: 70,
  sizeMonth: 140,
  startDiag: 300,
  yOffset: 85,
  yPadding: 50,
  heightRec: 25
}

export const oneRow = {
  id: '',
  idAPI: '',
  start: todayString(),
  end: addDays(todayString(), 10),
  startPlan: todayString(),
  endPlan: addDays(todayString(), 10),
  progress: 0,
  dependencies: [],
  name: '',
  idWork: null,
  idMaterial: null,
  duration: 1,
  pos: 0,
  idGroup: null,
  value: null,
  valueMaterial: null,
  count: 0,
  textField: '',
  typeGant: typeGant[0].value,
  parent: null,
  parentValue: null,
  child: [],
  color: null,
  selected: false,
  idDateEndLink: null,
  idDateStartLink: null,
  idProjectLink: 0
}